const isWindowUndefined = () => (typeof window === 'undefined');

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export default {
  isWindowUndefined,
  sleep,
};
